/**
 * @generated SignedSource<<7c6e58d501ce8a638bc7ebe996eb52f5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type PlanSlug = "BANQUET" | "CHEFS_SPECIAL" | "DEGUSTER" | "GOURMET" | "TWOHDSC" | "%future added value";
export type SubscriptionStatus = "ACTIVE" | "CANCELLED" | "PAST_DUE" | "PENDING" | "%future added value";
export type RestaurantOrdersPageViewerQuery$variables = {};
export type RestaurantOrdersPageViewerQuery$data = {
  readonly viewer: {
    readonly capabilities: ReadonlyArray<{
      readonly resolvedValue: string;
      readonly slug: string;
    }>;
    readonly pendingExcessCharge: {
      readonly createdAt: any;
      readonly month: string;
    } | null;
    readonly subscription: {
      readonly id: string;
      readonly isPastDue: boolean;
      readonly pastDueAt: any | null;
      readonly plan: PlanSlug;
      readonly status: SubscriptionStatus;
      readonly valueCents: number;
    } | null;
    readonly user: {
      readonly id: string;
      readonly restaurant: {
        readonly estimatedDeliveryTime: number | null;
        readonly id: string;
        readonly imageUrl: string | null;
        readonly name: string;
        readonly specialHours: ReadonlyArray<{
          readonly date: any;
          readonly isOpen: boolean;
          readonly periods: ReadonlyArray<{
            readonly close: string;
            readonly open: string;
          }>;
          readonly reason: string | null;
        }>;
        readonly weeklySchedule: {
          readonly friday: {
            readonly isOpen: boolean;
            readonly periods: ReadonlyArray<{
              readonly close: string;
              readonly open: string;
            }>;
          };
          readonly monday: {
            readonly isOpen: boolean;
            readonly periods: ReadonlyArray<{
              readonly close: string;
              readonly open: string;
            }>;
          };
          readonly saturday: {
            readonly isOpen: boolean;
            readonly periods: ReadonlyArray<{
              readonly close: string;
              readonly open: string;
            }>;
          };
          readonly sunday: {
            readonly isOpen: boolean;
            readonly periods: ReadonlyArray<{
              readonly close: string;
              readonly open: string;
            }>;
          };
          readonly thursday: {
            readonly isOpen: boolean;
            readonly periods: ReadonlyArray<{
              readonly close: string;
              readonly open: string;
            }>;
          };
          readonly tuesday: {
            readonly isOpen: boolean;
            readonly periods: ReadonlyArray<{
              readonly close: string;
              readonly open: string;
            }>;
          };
          readonly wednesday: {
            readonly isOpen: boolean;
            readonly periods: ReadonlyArray<{
              readonly close: string;
              readonly open: string;
            }>;
          };
        } | null;
      } | null;
      readonly role: string;
    } | null;
  };
};
export type RestaurantOrdersPageViewerQuery = {
  response: RestaurantOrdersPageViewerQuery$data;
  variables: RestaurantOrdersPageViewerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "role",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageUrl",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimatedDeliveryTime",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isOpen",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "TimeRange",
  "kind": "LinkedField",
  "name": "periods",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "open",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "close",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = [
  (v5/*: any*/),
  (v6/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "WeeklySchedule",
  "kind": "LinkedField",
  "name": "weeklySchedule",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "DaySchedule",
      "kind": "LinkedField",
      "name": "monday",
      "plural": false,
      "selections": (v7/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DaySchedule",
      "kind": "LinkedField",
      "name": "tuesday",
      "plural": false,
      "selections": (v7/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DaySchedule",
      "kind": "LinkedField",
      "name": "wednesday",
      "plural": false,
      "selections": (v7/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DaySchedule",
      "kind": "LinkedField",
      "name": "thursday",
      "plural": false,
      "selections": (v7/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DaySchedule",
      "kind": "LinkedField",
      "name": "friday",
      "plural": false,
      "selections": (v7/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DaySchedule",
      "kind": "LinkedField",
      "name": "saturday",
      "plural": false,
      "selections": (v7/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DaySchedule",
      "kind": "LinkedField",
      "name": "sunday",
      "plural": false,
      "selections": (v7/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "date",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reason",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "RestaurantSubscription",
  "kind": "LinkedField",
  "name": "subscription",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "plan",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "valueCents",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isPastDue",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pastDueAt",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "RestaurantCapabilityValue",
  "kind": "LinkedField",
  "name": "capabilities",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "resolvedValue",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "month",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "RestaurantOrdersPageViewerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Restaurant",
                "kind": "LinkedField",
                "name": "restaurant",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SpecialHours",
                    "kind": "LinkedField",
                    "name": "specialHours",
                    "plural": true,
                    "selections": [
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v11/*: any*/),
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ExcessOrderCharge",
            "kind": "LinkedField",
            "name": "pendingExcessCharge",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              (v14/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "RestaurantOrdersPageViewerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Restaurant",
                "kind": "LinkedField",
                "name": "restaurant",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SpecialHours",
                    "kind": "LinkedField",
                    "name": "specialHours",
                    "plural": true,
                    "selections": [
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v0/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v11/*: any*/),
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ExcessOrderCharge",
            "kind": "LinkedField",
            "name": "pendingExcessCharge",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              (v14/*: any*/),
              (v0/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "163df394c47d11b7073d4889ac876218",
    "id": null,
    "metadata": {},
    "name": "RestaurantOrdersPageViewerQuery",
    "operationKind": "query",
    "text": "query RestaurantOrdersPageViewerQuery {\n  viewer {\n    user {\n      id\n      role\n      restaurant {\n        id\n        name\n        imageUrl\n        estimatedDeliveryTime\n        weeklySchedule {\n          monday {\n            isOpen\n            periods {\n              open\n              close\n            }\n          }\n          tuesday {\n            isOpen\n            periods {\n              open\n              close\n            }\n          }\n          wednesday {\n            isOpen\n            periods {\n              open\n              close\n            }\n          }\n          thursday {\n            isOpen\n            periods {\n              open\n              close\n            }\n          }\n          friday {\n            isOpen\n            periods {\n              open\n              close\n            }\n          }\n          saturday {\n            isOpen\n            periods {\n              open\n              close\n            }\n          }\n          sunday {\n            isOpen\n            periods {\n              open\n              close\n            }\n          }\n        }\n        specialHours {\n          date\n          reason\n          isOpen\n          periods {\n            open\n            close\n          }\n          id\n        }\n      }\n    }\n    subscription {\n      id\n      plan\n      status\n      valueCents\n      isPastDue\n      pastDueAt\n    }\n    capabilities {\n      slug\n      resolvedValue\n    }\n    pendingExcessCharge {\n      month\n      createdAt\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "84579a977a7e7058656035978555d8e6";

export default node;
